import { Controller } from "stimulus";
import Swiper from 'swiper';
import { Navigation, EffectFade, Autoplay } from 'swiper/modules';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import 'swiper/css';

export default class extends Controller {
  connect() {
    this.bind()
  }

  bind() {
    const swiper = new Swiper('.swiper-container', {
      modules: [Navigation, EffectFade, Autoplay],
      direction: 'horizontal',
      slidesPerView: 1,
      loop: true,
      centeredSlides: true,
      speed: 1500,
      autoHeight: true,
      effect: 'fade',
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    })
  }
}

